import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';



const AfficheDonner = async (idClient) => {
    return await axios.get(`${BASE_URL}/api/client/afficherDonner/${idClient}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
        }
    });
}


const ModificationDonner = async (idClient, data) => {
    return await axios.put(`${BASE_URL}/api/client/modificationDonner/${idClient}`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
        }
    });
}
const ModificationPassword = async (idClient, data) => {
    return await axios.put(`${BASE_URL}/api/client/modificationPassword/${idClient}`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
        }
    });
}


export { ModificationDonner, ModificationPassword, AfficheDonner }